import React, { useState, useEffect } from 'react';
import { Breadcrumb, Row, Col, Pagination } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { buildQueryString, parseQueryString } from '@rd-web-markets/shared/dist/services/service';
import reportIssuesService from '@rd-web-markets/shared/dist/services/report_issues.service';
import ReportIssuesForm from '@components/admin/report_issues/ReportIssuesForm';
import ReportIssuesTable from '@components/admin/report_issues/ReportIssueTable';
import { UserService } from '@rd-web-markets/shared/dist/services/user.service';

export default function ReportIssuesPage({accountType}) {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const [allUsers] = UserService.useFetchUsersForSelect();
  const usersById = allUsers.reduce((acc, u) => { acc[u.value] = u.label; return acc; }, {});

  const { reports, createReport, updateStatus, deleteReport, totalPages } =
    reportIssuesService.useCrud(setLoading);

  useEffect(() => {
    UserService.getCurrent().then((res) => setCurrentUser(res?.user));
  }, []);

  const handleCreate = async (formData) => {
    await createReport(formData);
    setShowForm(false);
  };

  const currentPage = parseInt(parseQueryString(location.search).page || 1);

  const handlePage = (pageNumber) => {
    const currentParams = parseQueryString(location.search);
    history.push({ search: `?${buildQueryString({ ...currentParams, page: pageNumber })}` });
  };

  const paginationItems = [];
  for (let number = 1; number <= totalPages; number++) {
    paginationItems.push(
      <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePage(number)}>
        {number}
      </Pagination.Item>
    );
  }

  return (
    <>
      <BreadcrumbsPortal>
        <Breadcrumb>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>{t('reports')}</Breadcrumb.Item>
        </Breadcrumb>
      </BreadcrumbsPortal>

      <Row className="justify-content-center mx-0 mt-4">
        <Col md={10}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>{t('reports')}</h4>
            <AddButton
              size="sm"
              variant="info"
              disabled={loading}
              onClick={() => setShowForm(prev => !prev)}
              text={showForm ? t('hide_form') : t('report_issue')}
            />
          </div>

          {showForm && (
            <ReportIssuesForm
              loading={loading}
              onSubmit={handleCreate}
              onCancel={() => setShowForm(false)}
            />
          )}

          <ReportIssuesTable
            reports={reports}
            usersById={usersById}
            currentUser={currentUser}
            onUpdateStatus={updateStatus}
            onDelete={deleteReport}
            loading={loading}
            accountType={accountType}
          />

          {totalPages > 1 && (
            <Pagination className="justify-content-end mt-3">{paginationItems}</Pagination>
          )}
        </Col>
      </Row>
    </>
  );
}
